import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import errorIcon from '../../assets/images/EmptyStates/error.jpg';
import BaseConfirmationDialog from './BaseConfirmationDialog';
import {ErrorType} from "../../constants/enums";

@injectIntl
@inject('appStore')
@observer
class ErrorDialog extends Component {
    onRefresh = () => {
        window.location.reload();
    }

    render() {
        const {appStore} = this.props;
        if (appStore.error && appStore.error.type === ErrorType.NotFound) {
            return <BaseConfirmationDialog
                onDismiss={appStore.resetError}
                onSubmit={appStore.resetError}
                open={appStore.error !== null}
                onOutsideClick={appStore.resetError}
                windowIcon={errorIcon}
                buttonText='ok'
                text={{question: 'general.error.title', message: 'general.error.notfound.message'}}
                isCancel={false}
            />
        }
        return <BaseConfirmationDialog
            onDismiss={appStore.resetError}
            onSubmit={this.onRefresh}
            open={appStore.error !== null}
            onOutsideClick={appStore.resetError}
            windowIcon={errorIcon}
            buttonText='refresh'
            text={{question: 'general.error.title', message: 'general.error.message'}}
            isCancel={false}
        />
    }
}

export default ErrorDialog;
